export const DEVICE_EVENT_TYPES = {
  // this is used for getting initial device state and connectivity data depends on accessory api (smart home sensor card)
  //grouped by device type
  door_window_sensor: ['accessory_state_update_door_window_sensor_open'],
  smart_plug: ['accessory_state_update_smart_plug_on', 'accessory_state_lan_smart_plug'],
  occupancy_sensor: [
    'accessory_state_update_occupancy_sensor_active',
    'accessory_state_update_occupancy_sensor_wet',
  ],
  cooktop_sensor: ['cts_detection_event'],
  toilet_flush_sensor: [
    'accessory_state_update_toilet_flush_sensor_active',
    'accessory_state_ble_toilet_flush_sensor',
  ],
  temperature_sensor: ['accessory_state_ble_temperature_sensor'],
  environmental_sensor: [
    'sensor_battery_report',
    'sensor_humidity_report',
    'sensor_light_report',
    'sensor_temperature_report',
  ],
  radar_sensor: ['radar_presence_event'],
};

export const DEVICE_EVENT_TYPES_CHARTS = {
  //this constant is used for charts
  door_window_sensor: ['accessory_state_update_door_window_sensor_open'],
  smart_plug: ['accessory_report_smart_plug_recent_energy'],
  occupancy_sensor: [
    'accessory_state_update_occupancy_sensor_active',
    'accessory_state_update_occupancy_sensor_wet',
  ],
  cooktop_sensor: ['cts_detection_event'],
  toilet_flush_sensor: [
    'accessory_state_update_toilet_flush_sensor_active',
    'accessory_state_ble_toilet_flush_sensor',
  ],
  temperature_sensor: ['accessory_state_ble_temperature_sensor'],
  environmental_sensor: [
    'sensor_battery_report',
    'sensor_humidity_report',
    'sensor_light_report',
    'sensor_temperature_report',
  ],
  radar_sensor: ['radar_presence_event'],
};

export const DEVICE_TYPES = {
  DOOR_WINDOW_SENSOR: 'door_window_sensor',
  SMART_PLUG: 'smart_plug',
  OCCUPANCY_SENSOR: 'occupancy_sensor',
  COOKTOP_SENSOR: 'cooktop_sensor',
  TOILET_FLUSH_SENSOR: 'toilet_flush_sensor',
  TEMPERATURE_SENSOR: 'temperature_sensor',
  ENVIRONMENTAL_SENSOR: 'environmental_sensor',
  RADAR_SENSOR: 'radar_sensor',
};

export const EVENT_STATUS = {
  COMPLETED: 'completed',
  EXPIRED: 'expired',
  ONGOING: 'ongoing',
};

export const NOTIFICATION_MESSAGE_TYPE = {
  CALL_STATUS: 'call_status',
};

export const SCHEDULE_EVENT_TYPE = {
  SCHEDULE: 'schedule',
};

export const RECENT_ACTIVITY_EVENT_TYPES = {
  MOTION_DETECTED: 'motion_detected',
  COMPLETED_CALLS: 'completed_calls',
  ENGAGEMENT_BUNDLE: 'engagement_bundle',
};

export const FEATURE_FLAG_CONFIG = {
  wellness: 'biometrics_enable',
  environmental: 'smarthome_enable',
};

export const OCCUPANCY_SENSOR_STATES = {
  OCCUPIED: 'Occupied',
  OCCUPIED_DISCONNECTED: 'OccupiedDisconnected',
  VACANT: 'Vacant',
  VACANT_DISCONNECTED: 'VacantDisconnected',
};

export const INCONTINENCE_SENSOR_STATES = {
  WET: 'WET',
  WET_DISCONNECTED: 'WetDisconnected',
  DRY: 'DRY',
  DRY_DISCONNECTED: 'DryDisconnected',
};

export const SENSOR_VARIANTS = {
  OCCUPANCY_MOTION: 'occupancy_motion',
  INCONTINENCE: 'incontinence',
};

export const MODEL_TO_VARIANT = {
  INS: SENSOR_VARIANTS.INCONTINENCE,
};

export const DEVICE_CONNECTION_STATUS = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  smart_plug: ['accessory_report_smart_plug_recent_energy'],
  cooktop_sensor: ['cts_detection_event'],
  PAIRED: 'PAIRED',
  UNPAIRED: 'UNPAIRED',
};

export const EVENT_PROPERTIES = {
  DEVICE_UUID: 'deviceuuid',
  ENTITY_UUID: 'entity_uuid',
  MODEL_NUMBER: 'modelnumber',
  TIMESTAMP: 'utc_timestamp_inms',
  EVENT_TYPE: 'event_type',
  DISPLAY_TEXT: 'display_text',
  LOCATION: 'location',
  CONNECTED: 'connected',
  BATTERY_LEVEL: 'battery_level',
  MESSAGE_TYPE: 'message_type',
  MESSAGE_ID: 'message_id',
  RECV_TIME: 'recv_time',
  SEND_TIME: 'send_time',
  UTC_TIMESTAMP: 'utc_timestamp',
  CHANNEL_NAME: 'channel_name',
  APP_NAME: 'app_name',
  SUM: 'sum',
};

export const DEVICE_STATE_PROPERTY = {
  door_window_sensor: 'accessory_state_update_door_window_sensor_open__open',
  door_window_sensor_ble: 'accessory_state_ble_door_window_sensor__open',
  smart_plug: 'accessory_state_update_smart_plug_on__on',
  smart_plug_lan: 'accessory_state_lan_smart_plug__recent_energy',
  occupancy_sensor: 'accessory_state_update_occupancy_sensor_active__active',
  occupancy_sensor_ble: 'accessory_state_ble_occupancy_sensor__active',
  occupancy_sensor_incontinence: 'accessory_state_update_occupancy_sensor_wet__wet',
  radar_sensor: 'radar_presence_event__presence_type',
  cooktop_sensor: 'cts_detection_event__category',
  toilet_flush_sensor: 'accessory_state_update_toilet_flush_sensor_active__active',
  toilet_flush_sensor_ble: 'accessory_state_ble_toilet_flush_sensor__active',
  temperature_sensor: 'accessory_state_ble_temperature_sensor__temperature',
  temperature_sensor_unit: 'accessory_state_ble_temperature_sensor__temperature_unit',
  temperature_sensor_unit_2: 'sensor_temperature_report__temperature_unit',
  temperature_sensor_humidity: 'accessory_state_ble_temperature_sensor__humidity',
  cooktop_sensor_type: 'cts_detection_event__active_cooking_status',
};

export const SENSOR_PROPERTY = {
  ENVIRONMENTAL_SENSOR: {
    TEMPERATURE: 'sensor_temperature_report__observations',
    HUMIDITY: 'sensor_humidity_report__observations',
    AMBIENT_LIGHT: 'sensor_light_report__observations',
  },
};

export const DEVICE_EVENTS_PROPERTY = {
  accessory_state_update_door_window_sensor_open: 'open',
  accessory_state_ble_door_window_sensor: 'open',
  accessory_state_update_smart_plug_on: 'on',
  accessory_state_lan_smart_plug: 'on',
  accessory_report_smart_plug_recent_energy: 'value',
  accessory_state_update_occupancy_sensor_active: 'active',
  accessory_state_update_occupancy_sensor_wet: 'wet',
  accessory_state_ble_occupancy_sensor: 'active',
  radar_presence_event: 'presence_type',
  accessory_state_ble_temperature_sensor: 'temperature',
  accessory_state_ble_temperature_sensor_temperature_unit: 'temperature_unit',
  cts_detection_event__category: 'category',
  accessory_state_update_toilet_flush_sensor_active: 'active',
  accessory_state_ble_toilet_flush_sensor: 'active',
  'com.cooktopsafety.api.v1.exposed_burner': 'iseventdetected',
  'com.cooktopsafety.api.v1.presence': 'presence_status',
  'com.cooktopsafety.api.v1.active_cooking': 'iseventdetected',
  'com.cooktopsafety.api.v1.pot_too_hot': 'iseventdetected',
  'com.cooktopsafety.api.v1.unattended': 'iseventdetected',
  sensor_temperature_report: 'observations',
  sensor_temperature_report_temperature_unit: 'temperature_unit',
  sensor_humidity_report: 'observations',
  sensor_light_report: 'observations',
  humidity: 'humidity',
};

export const SENSOR_BATTERY_THRESHOLDS = {
  lowBatteryThreshold: 35,
  mediumBatteryThreshold: 49,
  fullBatteryThreshold: 50,
};

export const DEVICE_PRODUCT_CLASS = {
  SMART_HOME: 'smart_home',
  ENVIRONMENTAL_SENSOR: 'environmental_sensor',
};

export const SMART_PLUG_UNITS = {
  WH: 'Wh',
  KWH: 'kWh',
};

export const COOKTOP_CATEGORY = {
  UNATTENDED: 'cts_detection_event__unattended_status',
  POT_TOO_HOT: 'cts_detection_event__pot_too_hot_status',
  ACTIVE: 'cts_detection_event__active_cooking_status',
  PRESENCE: 'presence_status',
};

export const COOKTOP_ALERTS_TAB = 'cooktop_alerts';

export const PRODUCT_CLASS = {
  SMART_HOME: [
    'door_window_sensor',
    'smart_plug',
    'occupancy_sensor',
    'cooktop_sensor',
    'temperature_sensor',
    'radar_sensor',
  ],
};

export const RADAR_PRESENCE_TYPES = {
  FALL_DETECTED: 'fall_detected',
  FALL_RECOVERED: 'fall_recovered',
  OCCUPIED: 'occupied',
  VACANT: 'vacant',
  BED_IN: 'bed_in',
  BED_OUT: 'bed_out',
  COUCH_IN: 'couch_in',
  COUCH_OUT: 'couch_out',
  DOOR_IN: 'door_in',
  DOOR_OUT: 'door_out',
  SENSOR_MALFUNCTION: 'sensor_malfunction',
  SENSOR_RECOVERED: 'sensor_recovered',
};

export const RADAR_SENSOR_PRESENCE_COLORS = {
  fall_detected: '#FF4D4F', // Red — critical fall alert
  fall_recovered: '#FA8C16', // Orange — recovering from fall
  occupied: '#005d98', // Blue — general presence detected
  vacant: '#C8E1F5', // Light blue — no presence
  bed_in: '#52C41A', // Green — entered bed zone
  bed_out: '#B7EB8F', // Light green — left bed zone
  couch_in: '#13C2C2', // Teal — on couch
  couch_out: '#87E8DE', // Light teal — left couch
  door_in: '#722ED1', // Purple — entered door zone
  door_out: '#D3ADF7', // Lavender — exited door zone
  sensor_malfunction: '#8C8C8C', // Gray — sensor hardware issue
  sensor_recovered: '#BFBFBF', // Light gray — sensor restored
};

export const getRadarOccupancyState = (presenceType = '') => {
  const value = String(presenceType).toLowerCase();

  if (
    [
      RADAR_PRESENCE_TYPES.VACANT,
      RADAR_PRESENCE_TYPES.BED_OUT,
      RADAR_PRESENCE_TYPES.COUCH_OUT,
      RADAR_PRESENCE_TYPES.DOOR_OUT,
      RADAR_PRESENCE_TYPES.SENSOR_MALFUNCTION,
      RADAR_PRESENCE_TYPES.SENSOR_RECOVERED,
    ].includes(value)
  ) {
    return DEVICE_STATES.OCCUPANCY_SENSOR.VACANT;
  }

  if (
    [
      RADAR_PRESENCE_TYPES.OCCUPIED,
      RADAR_PRESENCE_TYPES.BED_IN,
      RADAR_PRESENCE_TYPES.COUCH_IN,
      RADAR_PRESENCE_TYPES.DOOR_IN,
      RADAR_PRESENCE_TYPES.FALL_DETECTED,
      RADAR_PRESENCE_TYPES.FALL_RECOVERED,
    ].includes(value)
  ) {
    return DEVICE_STATES.OCCUPANCY_SENSOR.OCCUPIED;
  }

  return '-';
};

export const SENSORS = {
  SMART_HOME: {
    DOOR_WINDOW_SENSOR: 'door_window_sensor',
    SMART_PLUG: 'smart_plug',
    COOKTOP_SENSOR: 'cooktop_sensor',
    OCCUPANCY_SENSOR: 'occupancy_sensor',
    TOILET_FLUSH_SENSOR: 'toilet_flush_sensor',
    TEMPERATURE_HUMIDITY_SENSOR: 'temperature_sensor',
    ENVIRONMENTAL_SENSOR: 'environmental_sensor',
    OUTDOOR_TEMPERATURE_HUMIDITY_SENSOR: 'outdoor_temperature_humidity_sensor',
    RADAR_SENSOR: 'radar_sensor',
  },
};

export const SENSOR_STATE_TITLE_MAPPING = {
  accessory_state_update_door_window_sensor_open: 'Open/Closed',
  accessory_state_update_smart_plug_on: 'On/Off',
  accessory_report_smart_plug_recent_energy: 'Active/Inactive',
  accessory_state_update_occupancy_sensor_active: 'Occupied/Vacant',
  accessory_state_update_occupancy_sensor_wet: 'Wet/Dry',
  radar_presence_event: 'Presence Events',
  accessory_state_ble_temperature_sensor: 'Temperature',
  accessory_state_update_toilet_flush_sensor_active: 'Flush Activity',
  accessory_state_ble_toilet_flush_sensor: 'Flush Activity',
  'com.cooktopsafety.api.v1.presence': 'Presence',
  'com.cooktopsafety.api.v1.active_cooking': 'Cooking Session',
  cooktop_alerts: 'Alerts',
  sensor_temperature_report: 'Temperature',
  sensor_humidity_report: 'Humidity',
  sensor_light_report: 'Ambient Light',
  humidity: 'Humidity',
};

export const EVENT_TYPES = {
  // list by event type
  DOOR_WINDOW_SENSOR: {
    ACCESSORY_STATE_BLE_DOOR_WINDOW_SENSOR: 'accessory_state_ble_door_window_sensor',
    ACCESSORY_STATE_UPDATE_DOOR_WINDOW_SENSOR_OPEN:
      'accessory_state_update_door_window_sensor_open',
  },
  SMART_PLUG: {
    ACCESSORY_STATE_UPDATE_SMART_PLUG_ON: 'accessory_state_update_smart_plug_on',
    ACCESSORY_REPORT_SMART_PLUG_RECENT_ENERGY: 'accessory_report_smart_plug_recent_energy',
    ACCESSORY_STATE_LAN_SMART_PLUG: 'accessory_state_lan_smart_plug',
  },
  OCCUPANCY_SENSOR: {
    ACCESSORY_STATE_BLE_OCCUPANCY_SENSOR: 'accessory_state_ble_occupancy_sensor',
    ACCESSORY_STATE_OCCUPANCY_SENSOR_ACTIVE: 'accessory_state_update_occupancy_sensor_active',
    ACCESSORY_STATE_UPDATE_OCCUPANCY_SENSOR_WET: 'accessory_state_update_occupancy_sensor_wet',
  },
  TEMPERATURE_HUMIDITY_SENSOR: {
    ACCESSORY_STATE_BLE_TEMPERATURE_SENSOR: 'accessory_state_ble_temperature_sensor',
  },
  ENVIRONMENTAL_SENSOR: {
    SENSOR_TEMPERATURE_REPORT: 'sensor_temperature_report',
    SENSOR_HUMIDITY_REPORT: 'sensor_humidity_report',
    SENSOR_LIGHT_REPORT: 'sensor_light_report',
    SENSOR_BATTERY_REPORT: 'sensor_battery_report',
    ACCESSORY_STATE_BLE_ENVIRONMENTAL_SENSOR: 'accessory_state_ble_environmental_sensor',
  },
  FLUSH_SENSOR: {
    ACCESSORY_STATE_BLE_TOILET_FLUSH_SENSOR: 'accessory_state_ble_toilet_flush_sensor',
    ACCESSORY_STATE_UPDATE_TOILET_FLUSH_SENSOR_ACTIVE:
      'accessory_state_update_toilet_flush_sensor_active',
  },
  COOKTOP_SENSOR: {
    EXPOSED_BURNER: 'com.cooktopsafety.api.v1.exposed_burner',
    PRESENCE: 'com.cooktopsafety.api.v1.presence',
    ACTIVE_COOKING: 'com.cooktopsafety.api.v1.active_cooking',
    POT_TOO_HOT: 'com.cooktopsafety.api.v1.pot_too_hot',
    UNATTENDED: 'com.cooktopsafety.api.v1.unattended',
    DETECTION: 'cts_detection_event',
  },
  RADAR_SENSOR: {
    RADAR_PRESENCE_EVENT: 'radar_presence_event',
  },
};

export const CHANNEL_EVENT_TYPES = {
  CHANNEL_LAUNCHED: 'channels_player_channel_launched',
  VIDEO_PLAY_STARTED: 'channels_player_video_play_started',
  VIDEO_PLAY_COMPLETED: 'channels_player_video_play_completed',
  VIDEO_PLAY_ABANDONED: 'channels_player_video_play_abandoned',
  VIDEO_PLAY_ERROR: 'channels_player_video_play_error',
};

// Views inside the Content Activity frame
export const CONTENT_ACTIVITY_VIEWS = {
  SUMMARY: 'summary',
  HISTORY: 'history',
  CHARTS: 'charts',
};

// Terminal viewing outcomes
export const VIDEO_PLAY_STATUS = {
  COMPLETED: 'completed',
  ABANDONED: 'abandoned',
};

// NOTE: The real userEventsApi response does NOT flatten payload fields with a
// `<message_type>__<field>` prefix (unlike biometric events) — fields are
// top-level on the event object (e.g. `video_id`, `channel_name`, `duration_ms`).
// These maps intentionally point at the plain field names so lookups stay
// centralized and consistent (no magic strings scattered across components).
export const CHANNEL_EVENT_FIELDS = {
  [CHANNEL_EVENT_TYPES.VIDEO_PLAY_STARTED]: {
    video_id: 'video_id',
    video_title: 'video_title',
    channel_id: 'channel_id',
    channel_name: 'channel_name',
    theme_id: 'theme_id',
    theme_name: 'theme_name',
    source_type: 'source_type',
    duration_ms: 'duration_ms',
  },
  [CHANNEL_EVENT_TYPES.VIDEO_PLAY_COMPLETED]: {
    video_id: 'video_id',
    video_title: 'video_title',
    channel_id: 'channel_id',
    channel_name: 'channel_name',
    total_watch_time_ms: 'total_watch_time_ms',
  },
  [CHANNEL_EVENT_TYPES.VIDEO_PLAY_ABANDONED]: {
    video_id: 'video_id',
    video_title: 'video_title',
    channel_id: 'channel_id',
    channel_name: 'channel_name',
    position_ms: 'position_ms',
    percent_watched: 'percent_watched',
    watch_duration_ms: 'watch_duration_ms',
  },
};

// Distinguishes duration-based "session" rows (from CHANNEL_EVENT_FIELDS above)
// from occurrence-only rows (channel opened / app opened, no known duration) in
// the Content Activity History list — see CHANNEL_OCCURRENCE_FIELDS below.
export const CONTENT_OCCURRENCE_KIND = {
  CHANNEL: 'channel',
  APP: 'app',
};

// Channel color + initials for avatars/charts (channel_id keyed; unknown channels
// fall back to a deterministic pick from CHANNEL_COLOR_PALETTE — see
// getChannelColor() in ContentActivityUtils.js).
export const CHANNEL_COLORS = {
  spiro100_eb: '#4FC3F7',
  discover_live_eb: '#81C784',
  stage_access_eb: '#CE93D8',
  zinnia_eb: '#FFB74D',
  memory_lane_eb: '#A1887F',
  faith_first_eb: '#90A4AE',
  music_first_eb: '#F48FB1',
};

// Distinct, colorblind-friendlyish palette used to deterministically color any
// channel not present in CHANNEL_COLORS (real channel ids often don't match the
// curated list above), so every channel gets its own stable color instead of
// all collapsing into one gray fallback.
export const CHANNEL_COLOR_PALETTE = [
  '#4FC3F7',
  '#81C784',
  '#CE93D8',
  '#FFB74D',
  '#A1887F',
  '#90A4AE',
  '#F48FB1',
  '#64B5F6',
  '#AED581',
  '#FF8A65',
  '#9575CD',
  '#4DB6AC',
];
export const CHANNEL_COLOR_FALLBACK = '#B0BEC5';

export const DEVICE_MODEL_NUMBERS = {
  EM200: 'EM200',
  INS: 'INS',
};

// Radar sensor model that must not allow unpairing from the Device Inventory modal.
export const UNPAIR_DISABLED_MODEL_NAMES = [];

export const TIME_RANGE = {
  TODAY: 'TODAY',
};

export const DEVICE_STATES = {
  FLUSH_SENSOR: {
    FLUSHED: 'flushed',
    NOT_FLUSHED: 'not_flushed',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
  },
  COOKTOP_SENSOR: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
  },
  DOOR_WINDOW_SENSOR: {
    OPEN: 'open',
    CLOSED: 'closed',
  },
  SMART_PLUG: {
    ON: 'on',
    OFF: 'off',
  },
  OCCUPANCY_SENSOR: {
    OCCUPIED: 'occupied',
    VACANT: 'vacant',
  },
  RADAR_SENSOR: {
    FALL_DETECTED: 'fall_detected',
    FALL_RECOVERED: 'fall_recovered',
    OCCUPIED: 'occupied',
    VACANT: 'vacant',
    BED_IN: 'bed_in',
    BED_OUT: 'bed_out',
    COUCH_IN: 'couch_in',
    COUCH_OUT: 'couch_out',
    DOOR_IN: 'door_in',
    DOOR_OUT: 'door_out',
    SENSOR_MALFUNCTION: 'sensor_malfunction',
    SENSOR_RECOVERED: 'sensor_recovered',
  },
};

export const CHANNEL_APP_TYPES = {
  WEB: 'web',
  NATIVE: 'native',
};

export const AUTO_REFRESH_DELAY = 120000;

export const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;

export const SMART_HOME_DEVICE_TYPES = [
  SENSORS.SMART_HOME.ENVIRONMENTAL_SENSOR,
  SENSORS.SMART_HOME.DOOR_WINDOW_SENSOR,
  SENSORS.SMART_HOME.SMART_PLUG,
  SENSORS.SMART_HOME.OCCUPANCY_SENSOR,
  SENSORS.SMART_HOME.COOKTOP_SENSOR,
  SENSORS.SMART_HOME.TOILET_FLUSH_SENSOR,
  SENSORS.SMART_HOME.TEMPERATURE_HUMIDITY_SENSOR,
  SENSORS.SMART_HOME.RADAR_SENSOR,
];

export const DEVICE_ALERTS_EVENTS = {
  INSIGHTS_SMART_HOME_ALERT_EVENT: 'insights_smart_home_alert_event',
  INSIGHTS_BIOMETRICS_ALERT_EVENT: 'insights_biometrics_alert_event',
  INSIGHTS_MOTION_ALERT_EVENT: 'insights_motion_alert_event',
};

/* Query param on the accounts route that auto-opens a hub dashboard, e.g. from an alert notification click */
export const HUB_DASHBOARD_QUERY_PARAM = 'accountuuid';

export const ENGAGEMENT_CHANNEL_EVENTS = [
  'channels_player_channel_launched',
  'channels_player_video_play_abandoned',
  'channels_player_video_play_completed',
  'channels_player_video_play_error',
  'channels_player_video_play_started',
];

export const ENGAGEMENT_BUNDLE_EVENT_TYPES = {
  CHANNEL_LAUNCHED: 'channels_player_channel_launched',
  APP_LAUNCH: 'app_launch_event',
};

export const ENGAGEMENT_CARD_EVENTS = [
  ENGAGEMENT_BUNDLE_EVENT_TYPES.CHANNEL_LAUNCHED,
  ENGAGEMENT_BUNDLE_EVENT_TYPES.APP_LAUNCH,
];

export const ENGAGEMENT_BUNDLE_SSE_EVENTS = [
  ENGAGEMENT_BUNDLE_EVENT_TYPES.CHANNEL_LAUNCHED,
  ENGAGEMENT_BUNDLE_EVENT_TYPES.APP_LAUNCH,
];

export const ENGAGEMENT_BUNDLE_SSE_EVENT_PROPERTIES = {
  [ENGAGEMENT_BUNDLE_EVENT_TYPES.CHANNEL_LAUNCHED]: {
    channel_name: 'channels_player_channel_launched__channel_name',
    channel_id: 'channels_player_channel_launched__channel_id',
  },
  [ENGAGEMENT_BUNDLE_EVENT_TYPES.APP_LAUNCH]: {
    app_name: 'app_launch_event__app_name',
    app_type: 'app_launch_event__app_type',
    app_details: 'app_launch_event__app_details',
  },
};

// Content Activity fetches the duration-based video-play lifecycle plus the two
// occurrence-only event types (channel opened / third-party app opened) so
// channels/apps without their own watch telemetry (e.g. Coro Health web apps,
// or a channel opened but never played) still show up in History — just
// without duration/completion data, which genuinely doesn't exist for them.
export const CONTENT_ACTIVITY_FETCH_EVENTS = [
  CHANNEL_EVENT_TYPES.VIDEO_PLAY_STARTED,
  CHANNEL_EVENT_TYPES.VIDEO_PLAY_COMPLETED,
  CHANNEL_EVENT_TYPES.VIDEO_PLAY_ABANDONED,
  CHANNEL_EVENT_TYPES.CHANNEL_LAUNCHED,
  ENGAGEMENT_BUNDLE_EVENT_TYPES.APP_LAUNCH,
];

// Field maps for the occurrence-only events (top-level fields, same convention
// as CHANNEL_EVENT_FIELDS above — confirmed against the real userEventsApi
// response, not flattened like the live SSE bundle above).
export const CHANNEL_OCCURRENCE_FIELDS = {
  [CHANNEL_EVENT_TYPES.CHANNEL_LAUNCHED]: {
    channel_id: 'channel_id',
    channel_name: 'channel_name',
  },
  [ENGAGEMENT_BUNDLE_EVENT_TYPES.APP_LAUNCH]: {
    app_name: 'app_name',
    app_type: 'app_type',
    app_details: 'app_details',
  },
};

export const SENSOR_SSE_EVENTS = [
  EVENT_TYPES.DOOR_WINDOW_SENSOR.ACCESSORY_STATE_BLE_DOOR_WINDOW_SENSOR,
  EVENT_TYPES.DOOR_WINDOW_SENSOR.ACCESSORY_STATE_UPDATE_DOOR_WINDOW_SENSOR_OPEN,
  EVENT_TYPES.SMART_PLUG.ACCESSORY_STATE_UPDATE_SMART_PLUG_ON,
  EVENT_TYPES.SMART_PLUG.ACCESSORY_STATE_LAN_SMART_PLUG,
  EVENT_TYPES.OCCUPANCY_SENSOR.ACCESSORY_STATE_BLE_OCCUPANCY_SENSOR,
  EVENT_TYPES.OCCUPANCY_SENSOR.ACCESSORY_STATE_OCCUPANCY_SENSOR_ACTIVE,
  EVENT_TYPES.OCCUPANCY_SENSOR.ACCESSORY_STATE_UPDATE_OCCUPANCY_SENSOR_WET,
  EVENT_TYPES.TEMPERATURE_HUMIDITY_SENSOR.ACCESSORY_STATE_BLE_TEMPERATURE_SENSOR,
  EVENT_TYPES.ENVIRONMENTAL_SENSOR.SENSOR_TEMPERATURE_REPORT,
  EVENT_TYPES.ENVIRONMENTAL_SENSOR.SENSOR_HUMIDITY_REPORT,
  EVENT_TYPES.ENVIRONMENTAL_SENSOR.SENSOR_LIGHT_REPORT,
  EVENT_TYPES.ENVIRONMENTAL_SENSOR.SENSOR_BATTERY_REPORT,
  EVENT_TYPES.ENVIRONMENTAL_SENSOR.ACCESSORY_STATE_BLE_ENVIRONMENTAL_SENSOR,
  EVENT_TYPES.FLUSH_SENSOR.ACCESSORY_STATE_BLE_TOILET_FLUSH_SENSOR,
  EVENT_TYPES.FLUSH_SENSOR.ACCESSORY_STATE_UPDATE_TOILET_FLUSH_SENSOR_ACTIVE,
  EVENT_TYPES.COOKTOP_SENSOR.DETECTION,
  EVENT_TYPES.RADAR_SENSOR.RADAR_PRESENCE_EVENT,
];

export const BIOMETRIC_SSE_EVENTS = [
  'blood_pressure_reading',
  'glucose_meter_reading',
  'pulse_oximeter_reading',
  'thermometer_reading',
  'weight_scale_reading',
];

export const BIOMETRIC_SSE_EVENT_PROPERTIES = {
  blood_pressure_reading: {
    systolic: 'blood_pressure_reading__systolic',
    diastolic: 'blood_pressure_reading__diastolic',
    pulse_rate: 'blood_pressure_reading__pulse_rate',
  },
  glucose_meter_reading: {
    glucose_concentration: 'glucose_meter_reading__glucose_concentration',
  },
  pulse_oximeter_reading: {
    spo2: 'pulse_oximeter_reading__spo2',
    pulse_rate: 'pulse_oximeter_reading__pulse_rate',
  },
  thermometer_reading: {
    temperature: 'thermometer_reading__temperature',
    temperature_unit: 'thermometer_reading__temperature_unit',
  },
  weight_scale_reading: {
    weight: 'weight_scale_reading__weight',
    weight_unit: 'weight_scale_reading__weight_unit',
  },
};

export const REMINDER_EVENT_TYPES = {
  CALENDAR_REMINDER: 'Calendar reminder',
  VISIT: 'Visit',
};

export const SESSION_STORAGE_KEYS = {
  FILTER: 'filter',
  INVENTORY_FILTER: 'inventory_filter',
  STAFF_FILTER: 'staff_filter',
  ACCOUNTS_VIEW: 'accounts_view',
};

export const SMART_PLUG_POWER_CONSUMPTION_THRESHOLD = 10; // in milliwatts

export const HC200_MODEL_NUMBER = 'HC200';

export const WELLNESS_HUB_DEVICE_TYPE = 'wellness_hub';

export const ACCESSORIES_PROPERTIES = {
  DEVICE_TYPE: 'devicetype',
  DEVICE_MAC_ADDRESS: 'device_mac_address',
  BASE_MAC_ADDRESS: 'basemacaddress',
  DEVICE_UUID: 'deviceuuid',
  PRODUCT_CLASS: 'productclass',
  MODEL_NUMBER: 'modelnumber',
  PAIRED_STATUS: 'paired_status',
  LOCATION: 'location',
  DEVICE_SERIAL_NUMBER: 'device_serial_number',
  DEVICE_BATTERY_LEVEL: 'device_battery_level',
  DEVICE_CONNECT_STATUS: 'deviceconnectstatus',
  DEVICE_CONNECTED: 'device_connected',
};

export const USER_MEASUREMENTS = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
};

export const DEVICE_UNITS = {
  TEMPERATURE: { F: 'F', C: 'C' },
  WEIGHT: { LBS: 'lbs', KG: 'kg' },
};

export const DEPLOYMENT_STATES = {
  DEPLOYED: 'DEPLOYED',
  NOT_DEPLOYED: 'NOT_DEPLOYED',
};

export const BIOMETRIC_DEVICE_TYPES = {
  BLOOD_PRESSURE: 'blood_pressure',
  GLUCOSE_METER: 'glucose_meter',
  PULSE_OXIMETER: 'pulse_oximeter',
  THERMOMETER: 'thermometer',
  WEIGHT_SCALE: 'weight_scale',
};

export const CONFIG_SMARTHOME_ENABLE_KEY = 'homesight_feature_config.smarthome_enable';

export const CONFIG_BIOMETRICS_ENABLE_KEY = 'homesight_feature_config.biometrics_enable';

export const CONFIG_SUPPORTED_DEVICES_KB_URL_KEY =
  'homesight_feature_config.supported_devices_kb_url';
export const CONFIG_DISPLAY_DEMOGRAPHIC_INFO_KEY =
  'homesight_web_config.web_config.display_demographic_info';
